import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import * as Sentry from "@sentry/react"
import { Container, Row, Col, Button } from "reactstrap"

import SessionLogo from "components/Common/SessionLogo"

const ProdErrorFallback = ({ error, componentStack, resetError }) => {
  const [eventId, setEventId] = useState(null)
  const [redirecting, setRedirecting] = useState(false)

  useEffect(() => {
    const lastId = Sentry.lastEventId()
    if (lastId) setEventId(lastId)
  }, [])

  const handleHome = () => {
    setRedirecting(true)
    resetError()
    window.location.assign("/start")
  }

  const handleRetry = () => {
    resetError()
  }

  return (
    <div className="account-pages pt-5 pb-5">
      <Container>
        <Row className="justify-content-center">
          <Col md="8" lg="6" xl="5">
            <div className="text-center mb-4">
              <SessionLogo />
            </div>

            <div className="card overflow-hidden shadow">
              <div className="card-body p-4">
                <div className="text-center">
                  <h4 className="text-uppercase text-danger pt-3">
                    Algo salió mal
                  </h4>
                  <p className="text-muted mb-3">
                    Ocurrió un error inesperado. Nuestro equipo ya fue
                    notificado y lo resolveremos a la brevedad.
                  </p>

                  {eventId && (
                    <p className="small text-muted mb-3">
                      Ref: <span className="font-monospace">{eventId}</span>
                    </p>
                  )}

                  <div className="mt-4 d-flex justify-content-center gap-2">
                    <Button
                      color="primary"
                      className="me-2"
                      onClick={handleRetry}
                      disabled={redirecting}
                    >
                      Reintentar
                    </Button>
                    <Button
                      color="light"
                      onClick={handleHome}
                      disabled={redirecting}
                    >
                      Ir al inicio
                    </Button>
                  </div>
                </div>
              </div>
            </div>

            <div className="text-center">
              <small className="text-muted">
                Si el problema persiste, contacta a soporte y menciona el código
                de referencia.
              </small>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

ProdErrorFallback.propTypes = {
  error: PropTypes.instanceOf(Error).isRequired,
  componentStack: PropTypes.string,
  resetError: PropTypes.func.isRequired,
}

export default ProdErrorFallback